<template>
	<v-layout class="column carousel-slider-container">
		<ItemMenuSlider />
	</v-layout>
</template>

<script>
import ItemMenuSlider from "@/components/carousel/ItemMenuSlider.vue";

export default {
	name: "Dormitory",
	data() {
		return {};
	},
	components: {
		ItemMenuSlider,
	},
};
</script>

<style lang="scss" src="./dormitory.scss"></style>
